import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingAccountUsageResponse } from './types';

export function useBillingAccountUsage(accountId: string | null) {
  const { data, error, isLoading, mutate } =
    useSWR<TBillingAccountUsageResponse>(
      accountId ? `commenda-billing/mirror/accounts/${accountId}/usage` : null,
      SWRFetcher({ method: 'GET' })
    );

  return { usage: data?.usage ?? null, error, isLoading, mutate };
}
